import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-border/40 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-br from-primary to-primary/80 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">F</span>
              </div>
              <span className="font-bold text-lg tracking-tight">FoundrScore</span>
            </Link>
            <p className="text-muted-foreground text-sm">
              Business plans are dead. Test. Score. Grow.
            </p>
          </div>

          {/* Tools */}
          <div>
            <h4 className="font-semibold text-sm mb-4 uppercase tracking-wider text-muted-foreground">Tools</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/quiz" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-quiz">
                  Quick Test
                </Link>
              </li>
              <li>
                <Link to="/assessment" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-assessment">
                  Full Assessment
                </Link>
              </li>
              <li>
                <Link to="/canvas" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-canvas">
                  Validation Canvas
                </Link>
              </li>
              <li>
                <Link to="/hub" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-hub">
                  My Hub
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-sm mb-4 uppercase tracking-wider text-muted-foreground">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-about">
                  About
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-pricing">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/waiting-list" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-waitlist">
                  Join Waiting List
                </Link>
              </li>
              <li>
                <a 
                  href="https://calendly.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  data-testid="footer-book-call"
                >
                  Book a Call
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-sm mb-4 uppercase tracking-wider text-muted-foreground">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-terms">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/40">
          <p className="text-center text-sm text-muted-foreground">
            © {new Date().getFullYear()} FoundrScore. All rights reserved. Made for UK founders.
          </p>
        </div>
      </div>
    </footer>
  );
}
